// Italian
export const it = {
    weeklyRewards: 'Premi settimanali in',
    days: 'giorni',
    hours: 'ore',
    minutes: 'min',
    seconds: 'sec',
    authenticating: 'Autenticazione',
    verifyWallet: 'Attendere mentre verifichiamo il tuo portafoglio',
    authRequired: 'Autenticazione richiesta',
    authFailed: 'Autenticazione fallita. Riprova.',
    points: 'Punti',
    rank: 'Posizione',
    of: 'di',
    players: 'giocatori',
    weeklyTopPlayers: 'Migliori giocatori della settimana',
    thisWeekLeaderboard: 'Classifica di questa settimana',
    rankingsReset: 'La classifica si azzera ogni domenica a mezzanotte UTC',
    yourPoints: 'I tuoi punti',
    dailyRewardAvailable: 'Premio giornaliero disponibile!',
    nextClaimAvailable: 'Prossimo riscatto disponibile in:',
    claimDailyReward: 'Riscatta premio giornaliero',
    claiming: 'Riscatto in corso...',
    multiplier: 'Moltiplicatore',
    bonusPointsMultiplier: 'Moltiplicatore punti bonus',
    outOf: 'di',
    loading: 'Caricamento...',
    errorLoading: 'Errore durante il caricamento',
    noEntries: 'Nessuna voce',
    leaderboard: 'Classifica',
    tasks: 'Attività',
    rules: 'Regole',
    profile: 'Profilo',
    comingSoon: 'Prossimamente...',
    completedTasks: 'Attività completate',
    dailyRewardsClaimed: 'Premi giornalieri riscossi',
    times: 'volte',
    recentActivity: 'Attività recente',
    noRewardsClaimed: 'Nessun premio ancora riscosso',
    dailyReward: 'Premio giornaliero',
    howItWorks: 'Come funziona',
    welcomeMessage:
        'Benvenuto in Coinomi Rewards! Guadagna punti completando varie attività e sali in classifica.',
    dailyRewardsTitle: 'Premi giornalieri',
    dailyRewardsRules: [
        'Riscatta il tuo premio giornaliero ogni 24 ore',
        'Ogni riscatto vale 100 punti',
        'I punti vengono moltiplicati per il tuo moltiplicatore',
    ],
    multiplierBonusesTitle: 'Bonus moltiplicatore',
    multiplierBonusesRules: [
        'Inizia con moltiplicatore 1x',
        'Collega Telegram per un bonus del +10%',
        'Verifica email per un bonus del +10%',
        'I bonus si accumulano per premi massimi',
    ],
    leaderboardTitle: 'Classifica',
    leaderboardRules: [
        'Competi con altri giocatori',
        'La classifica si aggiorna in tempo reale',
        'I migliori giocatori ricevono premi speciali',
    ],
    boostEarningsTitle: 'Aumenta i guadagni',
    boostEarningsRules: [
        'Completa sfide per bonus',
        'Unisciti alla nostra community Telegram',
        'Rimani attivo per premi massimi',
    ],
    challenges: 'Sfide',
    telegramChallenge: 'Sfida Telegram',
    emailChallenge: 'Sfida Email',
    connectTelegram: 'Collega Telegram',
    shareEmail: 'Condividi email',
    telegramSuccess: '🎉 Congratulazioni! Ora ricevi un bonus permanente del 10% su tutti i premi!',
    telegramPrompt:
        'Collega il tuo account Telegram per ricevere un bonus permanente del 10% su tutti i premi!',
    emailSuccess: '🎉 Congratulazioni! Ora ricevi un bonus permanente del 10% su tutti i premi!',
    emailPrompt:
        'Condividi la tua email per ricevere un bonus permanente del 10% su tutti i premi!',
    connectEmail: 'Collega email',
    cancel: 'Annulla',
    emailPrivacy:
        'Utilizziamo la tua email solo per aggiornamenti importanti e notifiche sui premi.',
    connectYourEmail: 'Collega la tua email',
    emailBonus: '🎉 Ricevi un bonus permanente del 10% su tutti i premi collegando la tua email!',
    enterValidEmail: 'Inserisci un indirizzo email valido',
    emailAddress: 'Indirizzo email',
    errorSavingEmail: "Errore durante il salvataggio dell'email. Riprova.",
    claimButton: 'Riscatta',
    earnedReward: 'Premio guadagnato',
    rewardValue: '{{amount}} Punti',
    claimingReward: 'Riscatto in corso...',
    claimSuccess: 'Riscossi con successo {{amount}} punti!',
    claimError: 'Riscatto fallito. Riprova.',
    privacyDisclaimer:
        'Coinomi non raccoglie dati personali; un sistema di terze parti gestisce in modo sicuro punti e connessioni sociali.',
    streakBonus: 'Bonus serie',
    streakDays: '{{days}}/5 Giorni',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% Extra',
    streakDescription: 'Riscatta per 5 giorni consecutivi per il bonus massimo',
    streakToday: 'Oggi',
    streakMissed: 'Perso',
    streakComplete: 'Completato',
    streakActive: 'Serie attiva',
    streakLost: 'Serie persa',
    streakNext: 'Prossimo',
    home: 'Home',
    currentStreak: 'Serie attuale',
    totalClaims: 'Riscatti totali',
    userStats: 'Le tue statistiche',
    referrals: 'Referral',
    referralProgram: 'Programma referral',
    howReferralWorks: 'Come funzionano i referral:',
    referralSteps: [
        'Condividi il tuo link referral con gli amici',
        'Quando si uniscono tramite il tuo link, diventano tuoi referral',
        'Guadagna punti bonus per ogni referral attivo',
        'Monitora i tuoi referral e guadagni qui',
    ],
    referralRewards: 'Punti referral assegnati:',
    referralBonuses: [
        '100 punti per referral',
        '10% di tutti i punti guadagnati dai tuoi referral',
    ],
    yourReferralLink: 'Il tuo link referral',
    copyToClipboard: 'Copia negli appunti',
    linkCopied: 'Link copiato negli appunti!',
    totalReferrals: 'Referral totali',
    yourReferralCode: 'Il tuo codice referral',
    referralCodeCopied: 'Codice referral copiato!',
    editReferralCode: 'Modifica codice referral',
    editReferralCodeInstructions:
        'Scegli un nuovo codice referral. Deve contenere almeno 5 caratteri e può includere lettere e numeri.',
    newReferralCode: 'Nuovo codice referral',
    referralCodeRequirements: 'Minimo 5 caratteri, solo lettere e numeri',
    updating: 'Aggiornamento...',
    update: 'Aggiorna',
    referralCodeTaken: 'Questo codice referral è già in uso',
    haveReferralCode: 'Hai un codice referral?',
    enterReferralCodePrompt:
        'Se qualcuno ti ha fatto da referral, inserisci il loro codice qui per collegare gli account.',
    enterReferralCode: 'Inserisci codice referral',
    enterReferralCodeInstructions: 'Inserisci il codice referral che è stato condiviso con te.',
    referralCode: 'Codice referral',
    referralCodeFormat: 'Solo lettere e numeri',
    submitting: 'Invio in corso...',
    submit: 'Invia',
    enterCode: 'Inserisci codice',
    pleaseAddtoken: "Aggiungi il parametro token all'URL",
    authenticationError: "Si è verificato un errore durante l'autenticazione",
    noUserFound: 'Nessun utente trovato',
    userNotFoundMessage: 'Impossibile trovare i dati utente',
    backToHome: 'Torna alla home',
    retry: 'Riprova',
    baseMultiplier: 'Moltiplicatore base',
    telegramBonus: 'Bonus Telegram',
    referralChallenge: 'Sfida referral',
    referralChallengePrompt:
        'Invita amici e guadagna punti bonus! Ricevi 100 punti per ogni referral più il 10% dei loro guadagni.',
    startReferring: 'Inizia a fare referral',
    referralSuccess:
        '🎉 Congratulazioni! Hai fatto referral con successo e stai guadagnando punti bonus!',
    unranked: 'Non classificato',
    noPlayersYet: 'Sii il primo a unirti!',
    shareVia: 'Condividi tramite',
    shareOn: 'Condividi su {{network}}',
    shareInviteText:
        "🚀 Sto guadagnando crypto gratis con @CoinomiWallet!\n\nScarica Coinomi su coinomi.com/downloads e inserisci il mio codice referral {{referralCode}} per ottenere un bonus quando ti unisci a #Coinomi Rewards nell'app.",
    yourStatsThisWeek: 'Le tue statistiche questa settimana',
    pointsMultiplier: 'Moltiplicatore punti',
    yourRank: 'La tua posizione',
    rewards: 'Ricompense',
    daily: 'Giornaliero',
    weekly: 'Settimanale',
    claimRewards: 'Riscuoti ricompense',
    player: 'Giocatore',
    score: 'Punteggio',
    youHaveReferred_zero: 'Non hai ancora invitato nessun amico',
    youHaveReferred_one: 'Hai invitato 1 amico',
    youHaveReferred_other: 'Hai invitato {{count}} amici',
    referYourFriends: 'Invita i tuoi amici',
    dailyRewardTooltip: 'Torna ogni giorno per richiedere i tuoi punti e premi',
    weeklyRewardTooltip: 'I premi vengono distribuiti settimanalmente',
    copy: 'Copia',
    // Twitter Challenge
    twitterChallenge: 'Sfida Twitter',
    connectTwitter: 'Connetti Twitter',
    twitterSuccess:
        '🎉 Congratulazioni! Ora ricevi un bonus permanente del 10% su tutte le ricompense!',
    twitterPrompt:
        'Collega il tuo account Twitter per ottenere un bonus permanente del 10% su tutte le ricompense!',
    pleaseAddUserId: "Aggiungi il parametro userId all'URL",
    emailChallengePrompt:
        'Condividi la tua email per ricevere un bonus permanente del 10% su tutte le ricompense!',
    emailChallengeSuccess:
        '🎉 Collegato! Ora ricevi un bonus permanente del 10% su tutte le ricompense!',
    followKoalaWalletChallenge: 'Segui @coinomiWallet su Twitter per supportarci!',
    twitterAuthSuccessTitle: 'Twitter collegato con successo!',
    twitterAuthSuccessMessage:
        "Hai collegato con successo il tuo account Twitter. Ora puoi continuare a usare l'app.",
    continueToApp: "Continua all'app",
    twitter_like: 'Ha messo Mi piace a un tweet',
    twitter_retweet: 'Ha retwittato un tweet',
    disconnect: 'Disconnetti',
    followCoinomiWallet: 'Segui @coinomiWallet su Twitter per supportarci!',
    connectedBonus: '🎉 Connesso! Ora ricevi un bonus permanente del 10% su tutte le ricompense!',
};
